import ViewList from "../../../component/users/organization-admin/view-user-list/ViewList"

 
function ViewOrganizationAdmin() {
  return (
    <div className='page-body'>
    <ViewList/>
  </div>
  )
}

export default ViewOrganizationAdmin
